export default function SignalCard({ label, value, detail, tone = "neutral" }) {
  const tones = {
    good: "text-mint",
    warn: "text-goldSoft",
    bad: "text-rose",
    neutral: "text-white",
    info: "text-cyan",
  };

  return (
    <section className="dashboard-card min-h-[116px] p-4">
      <p className="text-xs font-medium uppercase text-muted">{label}</p>
      <div className={`mt-3 text-2xl font-semibold leading-tight ${tones[tone]}`}>{value}</div>
      {detail ? <p className="mt-2 text-sm leading-snug text-slate-400">{detail}</p> : null}
    </section>
  );
}
